import { MDBCol, MDBInput, MDBRow, MDBSelect, MDBTextArea } from 'mdb-react-ui-kit'
import React from 'react'

function FavoritesBillsDetails() {
    return (
        <>
            <MDBRow>
                <MDBCol className='m-1'>
                    <MDBSelect
                        data={[
                            { text: 'Positon', value: 1 },
                            { text: 'Two', value: 2 },
                            { text: 'Three', value: 3 },
                            { text: 'Four', value: 4 },
                            { text: 'Five', value: 5 },
                            { text: 'Six', value: 6 },
                            { text: 'Seven', value: 7 },
                            { text: 'Eight', value: 8 }
                        ]}
                    />
                </MDBCol>
                <MDBCol className='m-1'>
                    <MDBSelect
                        data={[
                            { text: 'Lists', value: 1 },
                            { text: 'Two', value: 2 },
                            { text: 'Three', value: 3 },
                            { text: 'Four', value: 4 },
                            { text: 'Five', value: 5 },
                            { text: 'Six', value: 6 },
                            { text: 'Seven', value: 7 },
                            { text: 'Eight', value: 8 }
                        ]}
                    />
                </MDBCol>
            </MDBRow>
            <MDBRow>
                <MDBCol className='m-1'>
                    <MDBTextArea className='mb-3' label="Notes" rows="{4}" />
                </MDBCol>
            </MDBRow>
        </>
    )
}

export default FavoritesBillsDetails;